/**
 * Base URL for the API. Empty by default so the storefront uses same-origin
 * relative paths (dev: Vite proxy -> Worker; prod: Worker routed on the same
 * apex/subdomain). Override with VITE_API_URL when the API is on another host.
 */
const rawBase = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '');

export const API_ROOT = `${rawBase}/api/v1`;

/** Resolve a product image key to a servable URL, or null when unset. */
export function imageUrl(imageKey: string | null): string | null {
  if (!imageKey) return null;
  return `${rawBase}/img/${imageKey}`;
}
